<!-- TEMPLATE -->
<template>
  <div class="dean-input-file">
    <div class="row">
      <div class="small-12 medium-12 large-12 hd-12 columns">
        <div class="input-items">
          <label>{{ label }} uploaden</label>
          <div class="input-container">
            <input
              type="file"
              :id="id + '-file-upload'"
              ref="fileUpload"
              @change="attachFile"
            />
          </div>
          <div v-if="button" class="upload">
            <div class="upload-inner" @click="submitFile">
              <dean-icon class="upload-inner-icon" :glyph="uploadIcon">
              </dean-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

import uploadIcon from '../svg/feather-icons/upload.svg';

// COMPONENTS
import deanIcon from './deanIcon.vue';

@Component({
  components: {
    deanIcon
  }
})
export default class deanInputFile extends Vue {
  uploadIcon: object = uploadIcon;
  fileUpload: any = {};
  file = '';

  // PROPS
  @Prop({ default: '' }) label!: string;
  @Prop({ default: 'fileUpload' }) id!: string;
  @Prop({ default: false }) button!: boolean;

  attachFile() {
    this.fileUpload = this.$refs.fileUpload as HTMLElement;
    console.log(this.fileUpload.files[0]);
    this.file = this.fileUpload.files[0];

    let formData = new FormData();
    formData.append('file', this.file);

    this.$emit('file-changed', formData);
  }

  submitFile() {
    this.fileUpload = this.$refs.fileUpload as HTMLElement;
    let formData = new FormData();
    formData.append('file', this.file);

    // RESET INPUT
    this.fileUpload = {};
    this.$emit('upload', formData);
  }

  mounted() {
    // RESET INPUT
    this.fileUpload = {};
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

.dean-input-file {
  padding: 10px;

  .input-items {
    @include display-flex();
    position: relative;
    justify-content: flex-start;
    width: 100%;
  }

  .input-container {
    display: block;
    width: 100%;
    height: 40px;
    padding: 18px 10px 2px 10px;
    border: 1px solid var(--color-light-shade-2, $color-light-shade-2);
    @include border-radius(10px);
    @include transition(all ease 0.8s);
  }

  .upload {
    padding: 0px 0px 0px 10px;

    .upload-inner {
      height: 40px;
      width: 40px;
      padding: 13.3333px;
      background: var(--color-light-shade-2, $color-light-shade-2);
      fill: var(--color-link, $color-link);
      @include border-radius(10px);
      cursor: pointer;
      transition: 0.8s;

      &:hover {
        fill: var(--color-link-shade-2, $color-link-shade-2);
        background: var(--color-light, $color-light);
      }

      .upload-inner-icon {
        height: 13.3333px;
        width: 13.3333px;
      }
    }
  }

  label {
    position: absolute;
    left: 0;
    top: -1px;
    font-size: 7.5pt;
    line-height: 0;
    height: 15px;
    padding: 10px;
    font-weight: 500;
    user-select: none;
    color: var(--color-dark-shade-4, $color-dark-shade-4);
    pointer-events: none;
    overflow: hidden;
    @include opacity(1, 0.8s);
    @include transition(all ease 0.4s);
    @include text-select-none();
  }
}
</style>
